<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">
                  Add New Region - District
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <form
                    ref="observer"
                    tag="form"
                    @submit.prevent="submitForm()"
                    class=""
                    :class="{ card: !isSubPage }"
                  >
                    <div class="grid">
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Region *</div>
                        <div id="ctrl-region-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('region')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlregion"
                            v-model="formData.region"
                            :options="app.menus.gwclRegionItems"
                            label="Region"
                            placeholder="Select ..."
                            :filter="true"
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('region')"
                            class="p-error"
                            >{{ getFieldError("region") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">District *</div>
                        <div id="ctrl-district-holder">
                          <InputText
                            ref="ctrldistrict"
                            v-model.trim="formData.district"
                            pattern="^[A-Za-z0-9-', ]+$"
                            label="District"
                            type="text"
                            placeholder="Enter District"
                            class="w-full"
                            :class="getErrorClass('district')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('district')"
                            class="p-error"
                            >{{ getFieldError("district") }}</small
                          >
                        </div>
                      </div>
                    </div>
                    <div v-if="showSubmitButton" class="text-center my-3">
                      <Button
                        class="p-button-primary p-button-rounded"
                        type="submit"
                        label="Submit"
                        icon="pi pi-send"
                        :loading="saving"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useAddPage } from "@/composables/addpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  pageName: {
    type: String,
    default: "region_districts",
  },
  routeName: {
    type: String,
    default: "region_districtsadd",
  },
  apiPath: {
    type: String,
    default: "region_districts/add",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterSave: {
    type: String,
    default: "Record added successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  pageData: {
    // use to set formData default values from another page
    type: Object,
    default: () => {},
  },
});
const app = useApp();
const formDefaultValues = {
  region: "",
  district: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    region: { required },
    district: { required },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  app.flashMsg(props.msgAfterSave);
  page.setFormDefaultValues(); //reset form data
  if (props.redirect) app.navigateTo(`/region_districts`);
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Add Region - District";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
<style scoped></style>
